/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Select from '../../components/Select';

class ContentHub {
	constructor() {
        this._wrapper = SelectorEngine.findOne('.p-view-all-content');
        if(!this._wrapper) {
			return;
		};
		this.init();
	}
	

	init() {
        this.dropdownContainer = SelectorEngine.findOne('.content-dropdown-container', this._wrapper);

        const contentType = SelectorEngine.findOne('.contentType .js-lta-select', this.dropdownContainer);
		this.contentTypeElement = Select.getInstance(contentType) || new Select(contentType);
		EventHandler.on(this.contentTypeElement._selectNativeElement, 'change', this.applyFilters.bind(this));

        const contentYear = SelectorEngine.findOne('.contentYear .js-lta-select', this.dropdownContainer);
		this.contentYearElement = Select.getInstance(contentYear) || new Select(contentYear);
		EventHandler.on(this.contentYearElement._selectNativeElement, 'change', this.applyFilters.bind(this));
	}

    applyFilters() {
        const selectedContentType = this.contentTypeElement._selectNativeElement.value;
        const selectedContentYear = this.contentYearElement._selectNativeElement.value;
        let finalUrl = window.location.pathname;
        if (!(selectedContentType == '' || selectedContentType == 'All')) {
            finalUrl  = finalUrl + '?contentType=' + selectedContentType;
        };
        if (!(selectedContentYear == '' || selectedContentYear == 'All')) {
            if(finalUrl.includes('contentType')) {
                finalUrl  = finalUrl + '&contentYear=' + selectedContentYear;     
            } else {
                finalUrl  = finalUrl + '?contentYear=' + selectedContentYear;
            }
        };
        window.location.href = finalUrl;
    }

}

const contentHub = new ContentHub();
export default contentHub;
